import { render, staticRenderFns } from "./CurrentFilters.vue?vue&type=template&id=09d81902&scoped=true"
import script from "./CurrentFilters.vue?vue&type=script&lang=ts"
export * from "./CurrentFilters.vue?vue&type=script&lang=ts"
import style0 from "./CurrentFilters.vue?vue&type=style&index=0&id=09d81902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d81902",
  null
  
)

export default component.exports